import { render, staticRenderFns } from "./phone-setting.vue?vue&type=template&id=523c24ce"
import script from "./phone-setting.vue?vue&type=script&lang=js"
export * from "./phone-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports